import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { DictionaryAPIService } from '../../../commons/services/dictionary-api.service';
import { StoreService } from '../../../commons/stores/store.service';

@Injectable()
export class AppService {
  constructor(
    private storeService: StoreService,
    private dictionaryAPIService: DictionaryAPIService
  ) {}

  getFooterLogoStyle$(): Observable<any> {
    return this.getLoginStyle$('footerLogoStyle');
  }

  getLoginBodyStyle$(): Observable<any> {
    return this.getLoginStyle$('backgroundImageStyle');
  }

  private getLoginStyle$(section: string): Observable<any> {
    return this.storeService[section].asObservable().pipe(
      filter(Boolean),
      switchMap((fileId: string) => of(this.getBackgroundImgStyle(fileId)))
    );
  }

  private getBackgroundImgStyle(fileId: string): object | null {
    if (fileId === 'default') {
      return {};
    }

    if (fileId) {
      const imageUrl = this.dictionaryAPIService.fileDownload(fileId);
      return { 'background-image': `url(${imageUrl})` };
    }

    return null;
  }
}
